const HeaderComponent = ({ title }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
            <h2 style={{ margin: 0 }}>{title}</h2>
        </div>
    );
};

export default HeaderComponent;

